import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    style={{ overflow: 'visible', ...props.style }}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.67}
      d="m17.5 17.5-2.917-2.917m1.667-4.166a5.833 5.833 0 1 1-11.667 0 5.833 5.833 0 0 1 11.667 0Z"
    />
  </svg>
);

export { SvgComponent as SearchIcon };

